import { Injectable } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { constant } from '../constant/constants';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { LoginUser } from '../model/loginuser.model';
import { Utility } from './utility.service';
import * as localForage from "localforage";
import { ActivatedRoute, Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpProvider } from '../http/http-provider.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  public currentUserSubject = new BehaviorSubject<LoginUser>(new LoginUser);
  public routerParameters: any;
  private intervalForUser: any;
  public loaderList: number[] = [];

  constructor(public showMessage: MessageService,
    public confirmationService: ConfirmationService,
    public translate: TranslateService,
    public router: Router, public activatedRoute: ActivatedRoute,public http : HttpProvider) { }

  successMessage(message: string) {
    this.showMessage.add({ severity: constant.promptMessageType.success,  detail: message, life: 4000 });
  }

  errorMessage(message: string, life: number = 4000) {
    this.showMessage.add({ severity: constant.promptMessageType.error, summary: '', detail: message, life: life });
  }

  infoMessage(message: string) {
    this.showMessage.add({ severity: constant.promptMessageType.info, summary: 'Information Message', detail: message, life: 4000 });
  }

  warnMessage(message: string) {
    this.showMessage.add({ severity: constant.promptMessageType.warn, summary: 'Warning Message', detail: message, life: 4000 });
  }

  infoConfirmationMessage(message: string) {
    this.confirmationService.confirm({ message: message, icon: 'pi pi-info-circle', header: 'Information', rejectLabel: this.translate.instant('Common.Close'), acceptVisible: false });
  }

  confirmationMessage(message = "Are you sure that you want to proceed?"): Promise<boolean> {
    return new Promise(resolve => {
      this.confirmationService.confirm({
        message,
        accept: () => {
          resolve(true);
        },
        reject: () => {
          resolve(false);
        }
      });
    });
  }

  public get currentUser(): LoginUser {
    return this.currentUserSubject.value;
  }

  get bearerToken(): string {
    let getTokenFromSessionStorage = this.getLocalStorageData('Token', constant.localStorageType.localStorage)
    return Utility.IsNotNullOrEmpty(getTokenFromSessionStorage) ? getTokenFromSessionStorage : undefined
  }

  public getLocalStorageData<T>(key: string, localStorageType: number = 0): any {
    try {
      if (constant.localStorageType.any === localStorageType)
        return localForage.getItem(key);
      else if (constant.localStorageType.localStorage === localStorageType) {
        let value = localStorage.getItem(key);
        if (value)
          return JSON.parse(value);
        else return null;
      }
      else if (constant.localStorageType.sessionStorage === localStorageType) {
        let value = sessionStorage.getItem(key);
        if (value)
          return JSON.parse(value);
        else return null;
      }
      else if (constant.localStorageType.cookiesStorage === localStorageType)
        return this.getCookie(key);
    }
    catch (e) {
      return null
    }
  }

  private setCookie(name: string, value: string, expireDuration: number = 0, path: string = '') {
    let d: Date = new Date();
    expireDuration = expireDuration === 0 ? expireDuration * 24 * 60 * 60 * 1000 : expireDuration;
    d.setTime(d.getTime() + expireDuration);
    let expires: string = `expires=${d.toUTCString()}`;
    let cpath: string = path ? `; path=${path}` : '';
    document.cookie = `${name}=${value}; ${expires};`;/*${cpath}*/
  }

  private getCookie(name: string) {
    let ca: Array<string> = document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        let cookieValue = c.substring(cookieName.length, c.length);
        if (cookieValue.startsWith("\""))
          cookieValue = cookieValue.substring(1, cookieValue.length);
        if (cookieValue.endsWith("\""))
          cookieValue = cookieValue.substring(0, cookieValue.length - 1);
        return cookieValue;
      }
    }
    return '';
  }

  private deleteCookie(name: string) {
    this.setCookie(name, '', -1);
  }
  public saveLocalStorageData(key: string, data: any, localStorageType: number = 0, cookieexpireDuration: number = 0) {
    if (constant.localStorageType.any === localStorageType)
      localForage.setItem(key, data);
    else if (constant.localStorageType.localStorage === localStorageType)
      localStorage.setItem(key, JSON.stringify(data).toString());
    else if (constant.localStorageType.sessionStorage === localStorageType)
      sessionStorage.setItem(key, JSON.stringify(data).toString());
    else if (constant.localStorageType.cookiesStorage === localStorageType)
      this.setCookie(key, JSON.stringify(data), cookieexpireDuration);
  }
  
  public setcurrentUser(user: LoginUser) {
    if (user && user?.Id > 0) {
      //this.navigationService.setMenuitemsForCurrentUser(user);
      //user.menuItemsForUser = Utility.copy(this.navigationService.menuItemsForUser);
      this.currentUserSubject.next(user);
      clearInterval(this.intervalForUser);
      const jwtHelper = new JwtHelperService();
      // this.intervalForUser = setInterval(() => {
      //   try {
      //     const decodedToken = jwtHelper.decodeToken(this.bearerToken);
      //     const isExpired = jwtHelper.isTokenExpired(this.bearerToken);
      //     if (Number(decodedToken?.name) === this.currentUser?.userId && this.currentUser?.userId > 0 && !isExpired) {
      //       this.http.post<User>("Reload", { refreshToken: this.currentUser.refreshToken }, { showloader: false, showerrormessage: false }).subscribe((data: User) => {
      //         this.setcurrentUserToken(data.token);
      //       })
      //     }
      //     else {
      //       clearInterval(this.intervalForUser); this.router.navigate(['/login']);
      //     }
      //   }
      //   catch {
      //     clearInterval(this.intervalForUser); this.router.navigate(['/login']);
      //   }
      // }, environment.refreshTokenTimeout);
    }
    else
      this.currentUserSubject.next(user);
  }
  public clearLocalStorageData() {
    localStorage.clear();
    sessionStorage.clear();
    localForage.clear();
  }

  HideShowLoader(isLoading:boolean) {
    if (isLoading) this.loaderList.push(this.loaderList.length + 1);
    if (!isLoading) this.loaderList.pop();
  }
  public setcurrentUserToken(token: string) {
    let currentUser = this.currentUser;
    currentUser.Token = token;
    if(Utility.IsNotNullOrEmpty(token) && token) {
      this.saveLocalStorageData('Token', token, constant.localStorageType.localStorage);
    }
    this.currentUserSubject.next(currentUser);
  }

}
